module.exports = __webpack_public_path__ + "static/media/LowSetupCost.4cd524ba.svg";